<div class="container">

    <div *ngIf="fileDetailsDesign.length > 0 || dataService.role == 'designer'" class="p-2">
        <div class="row align-items-end mb-2">
          <div class="col text-start" style="color: #205567;">Please upload Design and Visualisation files to deliver to Dentist</div>
          <hr>
        </div>
    </div>

  
    <div *ngIf="fileDetailsDesign.length > 0 || dataService.role == 'designer'">

      <div class="row">
        <div class="col d-flex gap-4" style="color: #205567;">
          <div>Design Files</div>
          <div (click)="imagesFile.click()" *ngIf="dataService.role == 'designer' && taskStatus=='IP'">
            <i class="fa fa-upload" style="color: #205567; cursor:pointer;"></i>
            <input hidden multiple (change)="addFileDetails($event, 'design')" #imagesFile type="file" id="imagesFile" accept=".stl,.zip">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col" style="color: #205567;">
          <div style="font-size: x-small;">(allowed file types: stl, zip)</div>
        </div>
      </div>

      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center gap-2" *ngFor="let file of fileDetailsDesign">
          <span style="color:#205567;"class="text-truncate">
            {{file.fileName}}
          </span>
          <div class="d-flex gap-4">
            <div (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567; cursor:pointer;"></i>
            </div>
            <div (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'designer' && taskStatus=='IP'">
              <i class="fa fa-trash" style="color: #205567; cursor:pointer;"></i>
            </div>
          </div>
        </li>
      </ul>
      <hr>
    </div>
  
    <div *ngIf="fileDetails3dVisualisation.length > 0 || dataService.role == 'designer'">
      <div class="row">
        <div class="col d-flex gap-4" style="color: #205567;">
          <div>3D Visualisation files</div>
          <div (click)="imagesFile.click()" *ngIf="dataService.role == 'designer' && taskStatus=='IP'">
            <i class="fa fa-upload" style="color: #205567; cursor:pointer;"></i>
            <input hidden multiple (change)="addFileDetails($event, 'visual')" #imagesFile type="file" id="imagesFile" accept=".html,.jpg,.jpeg,.png,.webp,.zip">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col" style="color: #205567;">
          <div style="font-size: x-small;">(allowed file types: html, jpg, jpeg, png, webp, zip)</div>
        </div>
      </div>


      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center gap-2" *ngFor="let file of fileDetails3dVisualisation">
          <div style="color: #205567;" class="text-truncate">
            {{file.fileName}}
          </div>
          <div class="d-flex gap-4">
            <div (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567;"></i>
            </div>
            <div (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'designer' && taskStatus=='IP'">
              <i class="fa fa-trash" style="color: #205567;"></i>
            </div>
          </div>
        </li>
      </ul>
      <hr>
    </div>
  



    <div *ngIf="fileDetailsCorrectedDesign.length > 0 || (dataService.role == 'designer' && taskStatus=='IC')">
      
      <div class="row">
        <div class="col d-flex gap-4" style="color: #205567;">
          <div>Corrected Design Files</div>
          <div (click)="imagesFile.click()" *ngIf="dataService.role == 'designer' && taskStatus=='IC'">
            <i class="fa fa-upload" style="color: #205567; cursor:pointer;"></i>
            <input hidden multiple (change)="addFileDetails($event, 'correcteddesign')" #imagesFile type="file" id="imagesFile" accept=".png,.jpg">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col" style="color: #205567;">
          <div style="font-size: x-small;">(allowed file types: png, jpg)</div>
        </div>
      </div>

      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center gap-2" *ngFor="let file of fileDetailsCorrectedDesign">
          <span style="color:#205567;"class="text-truncate">
            {{file.fileName}}
          </span>

          <div class="d-flex gap-4">
            <div (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567; cursor:pointer;"></i>
            </div>
            <div (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'designer' && taskStatus=='IC'">
              <i class="fa fa-trash" style="color: #205567; cursor:pointer;"></i>
            </div>
          </div>

        </li>
      </ul>
      <hr>
    </div>
  
    <div *ngIf="fileDetailsCorrected3dVisualisation.length > 0 || (dataService.role == 'designer' && taskStatus=='IC')">
      
      <div class="row">
        <div class="col d-flex gap-4" style="color: #205567;">
          <div>Corrected 3D Visualisation files</div>
          <div (click)="imagesFile.click()" *ngIf="dataService.role == 'designer' && taskStatus=='IC'">
            <i class="fa fa-upload" style="color: #205567; cursor:pointer;"></i>
            <input hidden multiple (change)="addFileDetails($event, 'correctedvisual')" #imagesFile type="file" id="imagesFile" accept=".png,.jpg">
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col" style="color: #205567;">
          <div style="font-size: x-small;">(allowed file types: pdf, svg)</div>
        </div>
      </div>
      
      <ul class="list-group">
        <li class="py-0 list-group-item d-flex justify-content-between align-items-center gap-2" *ngFor="let file of fileDetailsCorrected3dVisualisation">
          <div style="color: #205567;" class="text-truncate">
            {{file.fileName}}
          </div>

          <div class="d-flex gap-4">
            <div (click)="downloadFile(file.fileId, file.fileName)">
              <i class="fa fa-download" style="color: #205567; cursor:pointer;"></i>
            </div>
            <div (click)="removeFileDetails(file.fileId)" *ngIf="dataService.role == 'designer' && taskStatus=='IC'">
              <i class="fa fa-trash" style="color: #205567; cursor:pointer;"></i>
            </div>
          </div>

        </li>
      </ul>
      <hr>
    </div>




  
    <div class="row mt-4">
      <div class="col d-flex justify-content-end gap-4">
        <button class="customPreActivatedButtons" (click)="close()">Done</button>
        <button class="customPreActivatedButtons" (click)="deliver()" *ngIf="taskStatus=='IP' || taskStatus=='IC'">
          Deliver {{taskStatus=='IC' ? 'Correction' : ''}} to Dentist
        </button>
      </div>
    </div>
  
  </div>
  
  <div class="spinner-overlay" *ngIf="dataService.progressBarActiveForSlider">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>